import React from "react";
import PageTemplate from "../../components/PageTemplate";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { menuList } from "../../utils/menu";

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTemplate title={t(menuList[0].title)} menuList={menuList[0].list} backgroundImage="/imgs/bg_aboutus" />
      <div id="aboutus_wrap" style={{ maxWidth: "1440px", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Outlet />
      </div>
    </>
  );
};

export default AboutUs;
